export default class CategoryTreeProcess {
  constructor() {
    this.toPrint = [];
  }

  seeResults() {
    return this.toPrint;
  }

  createCategoryTree(categories, parentId = null, level = 0) {
    let categoriesTree = [];
    let filteredFlatCats = [];
    if (parentId === null) {
      level = 0;
      filteredFlatCats = categories.filter(cat => cat.motherCategoryId === 0);
    } else {
      filteredFlatCats = categories.filter(cat => cat.motherCategoryId === parentId);
    }
    for (let index in filteredFlatCats) {
      const category = {
        categoryId: filteredFlatCats[index].id,
        name: filteredFlatCats[index].name,
        color: filteredFlatCats[index].color,
        level,
      };

      category.children = this
        .createCategoryTree(categories, filteredFlatCats[index].id, level + 1);
      categoriesTree.push(category);
    }

    return categoriesTree;
  };

  createPrint(root) {
    if (!root) return undefined;
    const queue = [];
    queue.push(root);
    const levelDelimiter = '-';
    while (queue.length) {
      let current = queue[queue.length - 1];
      this.toPrint.push({
        id: current.categoryId,
        data: [
          current.level ? levelDelimiter.repeat(current.level) + current.name : current.name
        ],
        label: current.name,
        level: current.level,
        color: current.color,
      });

      if (current.children
        && current.children.length) {
        queue.pop();
        current.children.forEach(child => {queue.push(child)});
      } else {
        queue.pop();
      }
    }
  };
}






// WEBPACK FOOTER //
// ./src/helpers/unileverSales/categoryTreeProcess.js